import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';

import BuyBoxOffer from '@/components/buybox/BuyBoxOffer.vue';
import BuyBoxBundle from '@/components/buybox/BuyBoxBundle.vue';
import { useOfferImpressionTracking } from '@/helpers/composables/useOfferImpressionTracking';

import { useLanguageStore } from '@/helpers/composables/useStores';
// APPLE_QUALITY_TV_EXP
import { AppleQualityTvExpProps } from '@/components/experiments/QualityTvExp/types';
// APPLE_QUALITY_TV_EXP
type BuyboxRowOffer = TitleOfferFragment & {
	iconUrl?: string;
	icons?: string[];
	bundleId?: number;
	bundleTechnicalName?: string;
};

interface BuyBoxRowProps {
	title: TitleDetail;
	promoted?: boolean;
	inline?: boolean;
	hideCategoryLabel?: boolean;
	additionalContexts?: SnowplowContext[];
	sponsoredAd?: SponsoredAdFragment;
	offers?: BuyboxRowOffer[];
	// START AVOD
	isAVODActive?: boolean;
	// END AVOD
	// APPLE_BACKDROP_EXP_V2
	appleBackdropV2ExpActive?: boolean;
	// APPLE_BACKDROP_EXP_V2
	// APPLE_QUALITY_TV_EXP
	appleQualityTvExpProps?: AppleQualityTvExpProps;
	// APPLE_QUALITY_TV_EXP
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxRow',
  props: {
    title: null,
    promoted: { type: Boolean },
    inline: { type: Boolean },
    hideCategoryLabel: { type: Boolean },
    additionalContexts: { default: () => [] },
    sponsoredAd: null,
    offers: { default: () => [] },
    isAVODActive: { type: Boolean },
    appleBackdropV2ExpActive: { type: Boolean },
    appleQualityTvExpProps: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, promoted?: boolean, inline?: boolean, hideCategoryLabel?: boolean, additionalContexts: SnowplowContext[], sponsoredAd?: SponsoredAdFragment, offers: BuyboxRowOffer[], isAVODActive?: boolean, appleBackdropV2ExpActive?: boolean, appleQualityTvExpProps?: AppleQualityTvExpProps }



const { country, isTTBLanguage } = useLanguageStore();
const { onIntersection } = useOfferImpressionTracking({ additionalContexts: props.additionalContexts });

const bundleIds = [8, 210, 29];
const SkyNetflixBundle = {
	bundleId: 2,
	iconUrl: '/icon/79172280/s100/sky.{format}',
	icons: ['/icon/207360008/s100/netflix.{format}'],
	standardWebURL: 'https://www.awin1.com/awclick.php?gid=466322&mid=11005&awinaffid=400165&linkid=3414019&clickref=',
};
const bundleOffer = computed(() => {
	const offer = props.offers.find(el => bundleIds.includes(el.package.packageId));
	if (!offer) return undefined;

	const bundleOffer = { ...offer };
	bundleOffer.iconUrl = SkyNetflixBundle.iconUrl;
	bundleOffer.icons = SkyNetflixBundle.icons;
	bundleOffer.standardWebURL = SkyNetflixBundle.standardWebURL;

	return bundleOffer;
});
const isBundleCountry = computed(() => country.value === 'GB' || country.value === 'IE');

// START AVOD
const rowOffers = computed(() => {
	// Only show One Plex offer at a time.
	// + Always filtering out Justwatch-plex Provider as it's only used by partners.
	const AVODTechnicalName = props.isAVODActive
		? ['plex', 'justwatchplexchannel']
		: ['plexplayer', 'justwatchplexchannel'];
	return props.offers.filter(el => !AVODTechnicalName.includes(el.package.technicalName));
});
// END AVOD

return { __sfc: true,props, country, isTTBLanguage, onIntersection, bundleIds, SkyNetflixBundle, bundleOffer, isBundleCountry, rowOffers, BuyBoxOffer, BuyBoxBundle }
}

})